// extracted by mini-css-extract-plugin
export default {"servicePage":"ServicePage_servicePage__1oECK"};